import ScrollContainer from "react-indiana-drag-scroll";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Container,
  UncontrolledTooltip,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ClassMultipleChoice({
  question,
  answersStudent,
  correctAnswer,
  students,
  amountOfStudentresults,
  sliderSettings,
  questionIndex,
}) {
  var correctAnswerList = correctAnswer.split("[,]");

  return (
    <Card>
      <CardHeader>
        <CardTitle>{question}</CardTitle>
      </CardHeader>
      <CardBody>
        <Row>
          <Col lg={5}>
            <label style={{ fontWeight: "bolder" }}>
              <FormattedMessage id="CorrectAnswer" />
            </label>
            <br />
            <label>
              {correctAnswerList.map((answer, index) => {
                answer =
                  answer === "true" ? (
                    <FormattedMessage id="True" />
                  ) : answer === "false" ? (
                    <FormattedMessage id="False" />
                  ) : (
                    answer
                  );
                return (
                  <div key={"qa" + questionIndex + "ca" + index}>
                    {answer}&nbsp;
                    <br />
                  </div>
                );
              })}
            </label>
          </Col>
          <Col lg={7}>
            <Slider {...sliderSettings} style={{ width: "95%", height: "95%" }}>
              {answersStudent.map((item, index) => {
                var studentNames = "";
                item.studentIds.forEach((id) => {
                  var student = students.find((obj) => {
                    return obj.id === id;
                  });
                  if (!student) {
                    return;
                  }
                  studentNames +=
                    studentNames === "" ? student.name : ", " + student.name;
                });
                return (
                  <div
                    key={"qa" + questionIndex + "sa" + index}
                    className="px-4"
                    style={{ minWidth: "max-content", width: "max-content" }}
                  >
                    <>
                      <div
                        id={"mc-qa" + questionIndex + "sa" + index}
                        className="pb-4"
                        style={{
                          display: "inline-flex",
                          flexDirection: "column",
                        }}
                      >
                        <label style={{ fontWeight: "bolder" }}>
                          {Math.round(
                            (item.studentIds.length / amountOfStudentresults) *
                              100
                          )}
                          %&nbsp;
                          {item.isCorrect ? (
                            <span>
                              {"("}
                              <FormattedMessage id="Correct" />
                              {")"}
                            </span>
                          ) : (
                            <span>
                              {"("}
                              <FormattedMessage id="IncorrectOrPartlyCorrect" />
                              {")"}
                            </span>
                          )}
                        </label>
                        <label>
                          {item.answer
                            .split("[,]")
                            .map((answer, answerIndex) => {
                              answer =
                                answer === "true" ? (
                                  <FormattedMessage id="True" />
                                ) : answer === "false" ? (
                                  <FormattedMessage id="False" />
                                ) : (
                                  answer
                                );
                              return (
                                <div
                                  key={
                                    "qa" +
                                    questionIndex +
                                    "sa" +
                                    index +
                                    "a" +
                                    answerIndex
                                  }
                                >
                                  {answer}&nbsp;
                                  <br />
                                </div>
                              );
                            })}
                        </label>
                      </div>
                      <UncontrolledTooltip
                        target={"mc-qa" + questionIndex + "sa" + index}
                        placement="top"
                      >
                        {studentNames}
                      </UncontrolledTooltip>
                    </>
                  </div>
                );
              })}
            </Slider>
            <ScrollContainer>
              <Container>
                <Row style={{ flexWrap: "nowrap" }}></Row>
              </Container>
            </ScrollContainer>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
